<template>
  <div class="search-popup">

  </div>
</template>

<script>
import { geturl } from '@/utils/index';
import { getOpenid } from '@/api/index'
export default {
  data() {
    return {
      website: ''
    }
  },
  created() {
    let params = geturl();
    // 将state参数以#号分割，取出state值
    if (params && params.code) {
      this.website = params.state.split('#')[0];
      console.log(this.website);
      this.getOpenidlist(params.code)
    } else {
      this.$router.push('/code')
    }
  },
  methods: {
    // 获取openid
    getOpenidlist(val) {
      getOpenid({ code: val }).then(res => {
        let url = 'https://api.weixin.54zkjl.com/weixin/#/' + this.website + '?openId=' + res;
        localStorage.setItem('id', res);
        window.location.href = url;
      }).catch(err => {
        console.log(err)
      })
    }
  },

}
</script>

<style lang="less" scoped></style>